import { useHistory, useParams } from 'react-router-dom';

import LastView from 'utils/localStorage/LastView';

const Redirect = () => {
  const { organizationId } = useParams();
  const history = useHistory();
  const currentPath = history.location.pathname;

  // Split path and filter out empty elements and everything after organizationId
  const pathParts = currentPath.split('/').filter(Boolean);
  const orgIndex = pathParts.indexOf(organizationId);
  
  const normalizedPath = '/' + pathParts
    .slice(0, orgIndex !== -1 ? orgIndex + 1 : pathParts.length)
    .join('/');

  const targetRoute = LastView.read() || "events";
  LastView.write(targetRoute);

  const finalPath = `${normalizedPath}/${targetRoute}`;
  history.push(finalPath);

  return null;
};

export default Redirect;
